// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.res.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var TextField = require("@mui/material/TextField").default;

function MM_cmp_asrts_per_page(props) {
  var onCancel = props.onCancel;
  var onOk = props.onOk;
  var initAsrtsPerPage = props.initAsrtsPerPage;
  var match = React.useState(function () {
        return initAsrtsPerPage;
      });
  var setAsrtsPerPage = match[1];
  var asrtsPerPage = match[0];
  var actOk = function () {
    onOk(asrtsPerPage);
  };
  var actCancel = function () {
    onCancel();
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement(TextField, {
                            value: asrtsPerPage,
                            label: "Assertions per page",
                            size: "small",
                            style: {
                              width: "150px"
                            },
                            onChange: Expln_React_common.evt2str(function (str) {
                                  setAsrtsPerPage(function (param) {
                                        return str;
                                      });
                                }),
                            onKeyDown: MM_react_common.kbrdHnd2(MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actOk), MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, actCancel)),
                            autoFocus: true
                          }), React.createElement(Expln_React_Row.make, {
                            alignItems: "center",
                            children: Caml_option.some(null)
                          }, React.createElement(Button, {
                                onClick: (function (param) {
                                    onOk(asrtsPerPage);
                                  }),
                                variant: "contained",
                                children: "Ok"
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    onCancel();
                                  }),
                                children: "Cancel"
                              }))))
            });
}

var make = MM_cmp_asrts_per_page;

exports.make = make;
/* react Not a pure module */
